// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BrandModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

export type xBaseTheme = BaseTheme & { helpers: any };

export interface HelpersGroup {
    [key: string]: CallableFunction;
}

export enum CarouselCardType {
    Grid = "grid",
    MiniCard = "miniCard",
    Condensed = "condensed",
    Table = "table",
}

export interface CategoryPropertiesTypes {
    contentBody?: string;
    contentButtonLink?: string;
    contentButtonText?: string;
    contentHeading?: string;
    contentImage?: string;
}

export interface IVMICategoryModel {
    id: string;
    name: string;
}

export interface IVMIFilteredBrandModel extends BrandModel {
    categories: string[];
    urlSegment: string;
    isFeatured: boolean;
}
export interface FeaturedBrandsModule {
    url: string;
    title: string;
    featuredImageAltText: string;
    featuredImagePath: string;
    logoLargeImagePath: string;
    logoSmallImagePath: string;
    htmlContent?: string;
    metaDescription?: string;
}

export interface FeaturedBrandsParameter {
    numberOfBrandsToReturn?: number;
}

export const enum ImageSettingKey {
    category = "category",
    brand = "brand",
}

export type LocationGoogleMapMarkerType = "WAREHOUSE" | "LOCATION" | "SELECTED" | "CURRENT_LOCATION";

export interface IBlogModel {
    title: string;
    image: string;
    imageAltText: string;
    type: string;
    categories: string[];
    url: string;
    summary: string;
    date: string;
    publishDate: string;
}

export interface IBlogCollectionModel {
    pagination: PaginationModel;
    blogs: IBlogModel[];
}

export interface CustomPageLinkModel {
    title: string;
    url: string;
    type?: string | undefined;
    id: string;
    excludeFromNavigation?: boolean | undefined;
    openInNewWindow?: boolean;
    queryString?: string;
    isBillTrustLink?: boolean;
}
export interface CustomLinkModel {
    fields: {
        openInNewWindow: boolean;
        overriddenTitle: string;
        destination: LinkFieldValue;
        queryString?: string;
        isBillTrustLink?: boolean;
    };
}

export interface ImageModel {
    altText: string;
    imageLink: string;
    desktopImagePath: string;
    tabletImagePath: string;
    mobileImagePath: string;
    width: number;
    height: number;
}

export interface VideoModel {
    thumbnailUrl: string;
    videoURL: string;
    title: string;
    description: string;
    uploadDate: string;
    duration: string;
}
